import React from 'react'
import styled from 'styled-components'
import { financeColors } from '../tokens'

interface Props {
  title: React.ReactNode
  description?: React.ReactNode
  action?: React.ReactNode
}

const Wrap = styled.div`
  border: 1px dashed ${financeColors.borderStrong};
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  display: grid;
  gap: 10px;
  background: ${financeColors.surfaceInfo};
`

const Title = styled.div`
  color: ${financeColors.text};
  font-size: 16px;
  font-weight: 700;
`

const Description = styled.div`
  color: ${financeColors.textMuted};
  font-size: 13px;
`

const FinanceEmptyState: React.FC<Props> = ({ title, description, action }) => (
  <Wrap>
    <Title>{title}</Title>
    {description && <Description>{description}</Description>}
    {action}
  </Wrap>
)

export default FinanceEmptyState
